/**
 * <MobileScreen 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './MobileScreen.scss';
import RegisterUserModal from 'template/Modals/RegisterUser';
import MobileDetect from 'mobile-detect'

class MobileScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    return (
      <div className='mobile-screen'>
        <div className='container-fluid mobile-wrapper text-center'>
          <div className='mobile-content'>
            <img className='img-responsive mobile-logo' src={require('data/images/logo_blue@3x.png')} />
            {/* <h2 className='mobile-text-title'>{__('Already a user?', 'appwrapper')}</h2> */}
            <p className='mobile-text-title'>{__("For better user experience, please use 'ClassTopBase' on computer or tablet.", 'appwrapper')}</p>
            <p className='mobile-text-title'>{__('Or try our mobile app!', 'appwrapper')}</p>
            <button className='btn btn-primary btn-block mobile-btn' onClick={() => {
              window.location.href = 'https://smarturl.it/classtopteacher'
            }}>{__('Download teacher app', 'appwrapper')}</button>
            <button className='btn btn-primary btn-block mobile-btn' onClick={() => {
              window.location.href = 'https://smarturl.it/classtopstudent'
            }}>{__('Download student app', 'appwrapper')}</button>
            {/* <h2 className='mobile-text-title'>{__('Not a user?', 'appwrapper')}</h2>
            <button className='btn btn-default btn-block mobile-btn' onClick={() => RegisterUserModal({ type: 'mobile' })}>{__('Sign up', 'appwrapper')}</button> */}
          </div>
        </div>
      </div>
    );
  }
}

export default MobileScreen;



// WEBPACK FOOTER //
// ./src/containers/Main/MobileScreen.js